/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import toast, { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { CmbioPassword } from "store/login/loginSlice";

import CheckIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Cancel";
import { Box, Typography } from "@mui/material";

export default function ModalCambioPassword() {
  const location = useLocation();
  const dispatch = useDispatch();
  const requiereCambioPassword = useSelector((state) =>
    state.login.usuario?.username == "publico" ? false : state.login.usuario?.requiereCambioPassword
  );

  const [open, setOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    if (location.pathname !== "/") {
      setOpen(!!requiereCambioPassword);
    }
  }, [location.pathname, requiereCambioPassword]);

  const validaciones = {
    longitud: newPassword.length >= 8,
    mayuscula: /[A-Z]/.test(newPassword),
    minuscula: /[a-z]/.test(newPassword),
    numero: /[0-9]/.test(newPassword),
    especial: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword),
  };

  const cumpleTodos = Object.values(validaciones).every((v) => v === true);
  const coincide = newPassword === confirmPassword;

  const handleGuardar = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Completa ambos campos");
      return;
    }
    if (!cumpleTodos) {
      toast.error("La contraseña no cumple con los requisitos");
      return;
    }
    if (!coincide) {
      toast.error("Las contraseñas no coinciden");
      return;
    }

    const respuesta = await dispatch(CmbioPassword(newPassword));
    if (respuesta.code === "Ok") {
      setOpen(false);
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  const renderCondicion = (label, cumplido) => (
    <Box display="flex" alignItems="center" mb={0.5}>
      {cumplido ? (
        <CheckIcon style={{ color: "limegreen", fontSize: 18, marginRight: 8 }} />
      ) : (
        <CloseIcon style={{ color: "red", fontSize: 18, marginRight: 8 }} />
      )}
      <Typography fontSize={13} color="white" style={{ opacity: 0.8 }}>
        {label}
      </Typography>
    </Box>
  );

  return (
    <>
      <Dialog open={open}>
        <DialogTitle style={{ backgroundColor: "#1a2035", color: "white" }}>
          Cambio de contraseña requerido
        </DialogTitle>
        <DialogContent style={{ backgroundColor: "#1a2035", color: "white" }}>
          <TextField
            label="Nueva contraseña"
            type="password"
            fullWidth
            variant="outlined"
            value={newPassword}
            size="small"
            style={{ marginBottom: "1rem", marginTop: "1rem" }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setNewPassword(e.target.value)}
          />

          <TextField
            label="Confirmar contraseña"
            type="password"
            fullWidth
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            size="small"
            InputLabelProps={{ shrink: true }}
            style={{ marginBottom: "1rem" }}
          />

          <Box mt={2}>
            <Typography variant="subtitle2" color="white" mb={1}>
              La contraseña debe contener:
            </Typography>
            {renderCondicion("Al menos 8 caracteres", validaciones.longitud)}
            {renderCondicion("Una letra mayúscula", validaciones.mayuscula)}
            {renderCondicion("Una letra minúscula", validaciones.minuscula)}
            {renderCondicion("Un número", validaciones.numero)}
            {renderCondicion("Un carácter especial (!@#$...)", validaciones.especial)}
          </Box>
        </DialogContent>
        <DialogActions style={{ backgroundColor: "#1a2035" }}>
          <Button onClick={handleGuardar} variant="contained" size="small">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Toaster
        toastOptions={{
          style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" },
        }}
      />
    </>
  );
}
